// Determine the type of the primary media asset at the top of an article so we can segment
// SpeedCurve RUM by what renders in the hero slot (image, video, animation, etc.).
export default function getPrimaryAssetType () {
    const primaryMedia = document.querySelector('#primary-media');

    if (!primaryMedia) {
        return 'none';
    }

    if (primaryMedia.classList.contains('media-container')) {
        return primaryMedia.classList.contains('with-vertical-video') ? 'vertical-video' : 'video';
    }

    if (primaryMedia.querySelector('.media.image')) {
        return 'image';
    }

    if (primaryMedia.querySelector('.media.video')) {
        return 'animation';
    }

    return 'none';
}
